import React, { createContext, useState, useContext, useEffect } from 'react';
import { getPopularMovies } from '../services/movieService';
import { getTopBooks } from '../services/bookService';

const DataContext = createContext();

export function useData() {
  return useContext(DataContext);
}

export function DataProvider({ children }) {
  const [movies, setMovies] = useState([]);
  const [books, setBooks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const preloadData = async () => {
      try {
        // Load initial data for both movies and books
        const [moviesData, booksData] = await Promise.all([
          getPopularMovies(1, {}),
          getTopBooks(1, {})
        ]);

        setMovies(moviesData.results || []);
        setBooks(booksData.docs || []);
      } catch (error) {
        console.error('Error preloading data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    preloadData();
  }, []);

  const value = {
    preloadedMovies: movies,
    preloadedBooks: books,
    isLoading
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
} 